import React,{ useContext } from "react"
import { Form } from "semantic-ui-react"
import Panel from "../../../components/shared/Panel"
import PropTypes from 'prop-types'
import NationalitiesDropDown from "../../../components/shared/NationalitiesDropDown"
import GuestSearchDropDown from "../../../components/shared/GuestSearchDropDown"
import { useTextResources } from "../../../language"
import ReservationContext from "../context"

export const GuestPanel = ()=>{
    const text = useTextResources()
    const {guest} = useContext(ReservationContext)
    return <Panel header={text("GuestDetails")} icon="address card outline">
    <Form>
        <Form.Field 
            control={GuestSearchDropDown} 
            placeholder={text('SearchByNameEmailPhoneId')}
            label={text("Guest")} 
            guest={guest}
            value={guest.Id} />
        <Form.Group unstackable widths="2">
            <Form.Input label={text("Email")} defaultValue={guest?.Email}></Form.Input>
            <Form.Input label={text("Phone")} defaultValue={guest?.Phone}></Form.Input>
        </Form.Group>
        <Form.Group unstackable widths="2">
            <Form.Input label={text("IDNumber")} defaultValue={guest?.IdentityCardNumber}></Form.Input>
            <Form.Input label={text("Passport")} defaultValue={guest?.PassportNumber}></Form.Input>
        </Form.Group>
        <Form.Group unstackable widths="2">
            <Form.Field label={text("Nationality")} clearable control={NationalitiesDropDown} value={guest?.NationalityId}/>
        </Form.Group>
    </Form>
</Panel>
}
GuestPanel.propTypes = {
    guest: PropTypes.object
}